import React from "react";

const TONE = {
  green: { bg: "#E6F6EC", fg: "#067647", dot: "#0BA85A" },
  amber: { bg: "#FCF1DC", fg: "#8A6410", dot: "#E0A93B" },
  red: { bg: "#FBE9E7", fg: "#C0362C", dot: "#D9534F" },
  gray: { bg: "#F0F1F3", fg: "#667085", dot: "#98A2B3" },
};

export default function HealthBadge({ health, size = "md" }) {
  if (!health) return null;
  const t = TONE[health.tone] || TONE.gray;
  const pad = size === "sm" ? "2px 8px" : "4px 10px";
  const fs = size === "sm" ? 11 : 12;
  return (
    <span data-testid={`health-${health.tone}`} title={(health.reasons || []).join(" · ")}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, background: t.bg, color: t.fg,
        borderRadius: 999, padding: pad, fontSize: fs, fontWeight: 700, whiteSpace: "nowrap" }}>
      <span style={{ width: 7, height: 7, borderRadius: 999, background: t.dot }} />
      {health.label}
    </span>
  );
}
